import React from 'react';

const Wave = () => {
  return (
    <svg
      className="wave"
      width="378"
      height="331"
      viewBox="0 0 378 331"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M-25.375 403.746L377.453 403.746C326.352 384.878 321.434 331.567 294.906 298.479C256.58 250.679 239.872 294.805 208.426 258.035C180.049 224.858 186.412 175.842 150.444 133.029C110.026 84.9157 89.0381 137.171 55.1212 96.1224C24.5313 59.0944 27.6404 0.917953 -25.375 0.917951L-25.375 403.746Z"
        fill="#FFBF80"
      />
    </svg>
  );
};

export default Wave;
